import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Duration as LuxonDuration } from 'luxon';
import { isNumber } from 'lodash/fp';

export function Duration({ value, fallbackValue, ...props }) {
    // Converting to ISO string first will help luxon with proper formatting
    // in the next step.
    const iso = isNumber(value) ? LuxonDuration.fromMillis(value).rescale().toISO() : value;

    const d = LuxonDuration.fromISO(iso);
    const { t } = useTranslation();

    if (!d.isValid) {
        return (
            <span title={fallbackValue ?? t('common:notAvailable')} {...props}>
                {fallbackValue ?? t('common:naDashes')}
            </span>
        );
    }

    const displayValue = d
        .rescale()
        .toHuman({
            notation: 'compact',
            unitDisplay: 'narrow'
        })
        .replace(/,/g, ' ');

    return (
        <time dateTime={value} title={displayValue} {...props}>
            {displayValue}
        </time>
    );
}

Duration.propTypes = {
    /**
     * An ISO 8601 compatible duration string or number of milliseconds.
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * The value to display if no time value is provided
     */
    fallbackValue: PropTypes.string
};
